import dayjs from 'dayjs'

// d2 - d1を行った日付の差を秒にして返す
export const dateDiffSecond = (d1: Date, d2: Date): number => {
  return dayjs(d2).diff(d1, 'second')
}

export const formatDate = (d: Date, format?: string): string => {
  return dayjs(d).format(format ?? 'YYYY/MM/DD HH:mm:ss')
}
